import { ColumnDef } from "@tanstack/react-table";
import { DcddUserActivityProps,} from "modules/user_management/dcdd_user/users/state/actionType";

export const TableColumns: ColumnDef<DcddUserActivityProps>[] = [
  // {
  //   id: "slNo",
  //   header: "Sl. No",
  //   cell: ({ row }) => row.index + 1,
  // },
  {
    accessorFn: (row) => row.user?.user_profile?.name,
    id: "name",
    header: "Name",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.category,
    id: "category",
    header: "Category",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.email,
    id: "email",
    header: "Email",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.id,
    id: "user_id",
    header: "User ID",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.login_id,
    id: "login_id",
    header: "Login ID",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.mobile_no,
    id: "mobile_no",
    header: "Mobile No.",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.password,
    id: "password",
    header: "Password",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.student_id,
    id: "student_id_user",
    header: "Student Code",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.user_identifier,
    id: "user_identifier",
    header: "User Identifier",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.user_profile?.cid,
    id: "cid",
    header: "CID",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.user_profile?.dob,
    id: "dob",
    header: "Date of Birth",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.user_profile?.dzongkhag?.name,
    id: "dzongkhag",
    header: "Dzongkhag",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.user_profile?.school?.name,
    id: "name",
    header: "Dzongkhag",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.user_profile?.eccd?.name,
    id: "eccd",
    header: "ECCD",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.user_profile?.gender,
    id: "gender",
    header: "Gender",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.user_profile?.grade?.name,
    id: "grade",
    header: "Grade",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.user_profile?.id,
    id: "user_profile_id",
    header: "Profile ID",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.user_profile?.profile_picture,
    id: "user_profile_picture",
    header: "Profile Picture",
    cell: (info) => (
      <img
        src={info.getValue() as string}
        alt="Profile"
        className="w-10 h-10 rounded-full object-cover"
      />
    ),
  },
  {
    accessorFn: (row) => row.user?.user_profile?.student_id,
    id: "student_id_user_profile",
    header: "Student ID (Profile)",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.month,
    id: "month",
    header: "month",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.year,
    id: "year",
    header: "Year",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.activity_counts?.video_watched,
    id: "video_watch_count",
    header: "Video Watch Count",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.activity_counts?.CheyChey,
    id: "CheyChey",
    header: "CheyChey Count",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.activity_counts?.others,
    id: "other",
    header: "Other Count",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.total_count,
    id: "total_count",
    header: "Total Count",
    cell: (info) => info.getValue(),
  },
  {
    accessorFn: (row) => row.user?.status,
    id: "status",
    header: "Status",
    cell: (info) => info.getValue(),
  },
];
